<script lang="ts">
    import { onMount } from 'svelte';
    import { get } from 'svelte/store';
    import { storePodcast, storePodcastPlayer, storePodcastCategory } from "../scripts/classes/podcast";
    import { storeIsPodcastDisplayed } from '../scripts/store';
    import PopUp from '../components/PopUp.svelte';
    import { tick } from 'svelte';
    import { scrollTopMainRoute } from '../scripts/common';

    const websiteUrl = new URL(window.location.href).href;
    let unique = {}; // every {} is unique, {} === {} evaluates to false
    let showPopup = false;

    onMount(async() => {
        storePodcastCategory.set(get(storePodcast).podcast_category.toString());
    })

    tick().then(() => {
        scrollTopMainRoute();
    })

    function reloadPopUp() {
        unique = {};
        showPopup = true;
    }

    function togglePodcast() {
        storePodcastPlayer.set(get(storePodcast));
        if (!$storeIsPodcastDisplayed) {
            storeIsPodcastDisplayed.set(true);
        }
    }

    function share() {
        navigator.clipboard.writeText(websiteUrl);
        reloadPopUp();
    }

</script>

<style lang="scss">

</style>

<div class="pagemobile">
    <img class="pagemobile__image" src="../assets/images/podcasts/{$storePodcast.id}_{$storePodcast.photo_file_name}" alt="podcast">
    <h2 class="pagemobile__textcontent pagemobile__h2">{$storePodcast.title}</h2>
    <h3 class="pagemobile__textcontent pagemobile__h3">{$storePodcast.subtitle}</h3>
    <p class="pagemobile__textcontent pagemobile__p">{$storePodcast.date}</p>
    <p class="pagemobile__textcontent pagemobile__text">{@html $storePodcast.text}</p>
    <div class="pagemobile__footer">
        <div>
            <img  class="pagemobile__share" src="../assets/images/share.png" alt="share" title="Partagez moi !" on:click={() => share()} on:keydown={() => share()}/>
            <div class="pagemobile__share__copied">
                {#key unique}
                <PopUp props={{isDisplayed: showPopup, message: "copié !"}} />
                {/key}    
            </div>
        </div>
        <div class="pagemobile__listen" on:click={togglePodcast} on:keydown={togglePodcast}>Ecouter&nbsp;!!!</div>    
        {#if ($storePodcast.spotify != "")}
            <a href="{$storePodcast.spotify}" target="_blank"><div class="pagemobile__spotify"></div></a>
        {/if}
    </div>    
</div>
<div class="pageScroll">
    <div class="pageScroll__content">
        <div class="pageScroll__scroll">
            <div class="pageScroll__parallax">
                <img class="pageScroll__image" src="../assets/images/podcasts/{$storePodcast.id}_{$storePodcast.photo_file_name}" alt="podcast">
            </div>
            <div class="pageScroll__vu">
                <h2 class="pageScroll__h2">{$storePodcast.title}</h2>
                <h3 class="pageScroll__h3">{$storePodcast.subtitle}</h3>
                <p class="pageScroll__p">{$storePodcast.date}</p>
                <p class="pageScroll__text">{@html $storePodcast.text}</p>
                <div class="pageScroll__footer">
                    <div>
                        <img  class="pageScroll__share" src="../assets/images/share.png" alt="share" title="Partagez moi !" on:click={() => share()} on:keydown={() => share()}/>
                        <div class="pageScroll__share__copied">
                            {#key unique}
                            <PopUp props={{isDisplayed: showPopup, message: "copié !"}} />
                            {/key}    
                        </div>
                    </div>
                    <div class="pageScroll__listen" on:click={togglePodcast} on:keydown={togglePodcast}>Ecouter&nbsp;!!!</div>    
                    {#if ($storePodcast.spotify != "")}
                        <a href="{$storePodcast.spotify}" target="_blank"><div class="pageScroll__spotify"></div></a>
                    {/if}
                </div>    
            </div>
        </div>
    </div>
</div>
